<template>
  <div class="promo"  @click="routerPush" @click.right="routerPush">
    <Header />
    <div class="login-btn">
      <img src="@/assets/hand.png" alt="">
      <span class="btn-text">Toque em qualquer lugar <br> para acessar suas faturas</span>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'

import adminStore from "@/store/admin.store"
export default {
  components: {Header},
  methods: {
    routerPush() {
      this.$router.push('/usersignin')
    }
  },
   beforeMount () {
    const {id}  = adminStore.getters.admin
    if(!id) {
       this.$router.push('/signinadmin');
    }
  },
}
</script>

<style scoped>
.promo {
    position: relative;
    min-height: 100vh;
    width: 100%;
    background: url('../../assets/bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden !important;
}

.login-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 32px;
    position: absolute;
    width: 446px;
    height: 128px;
    left: 161px;
    top: 1058px;
    color: white;
    background: rgba(12, 204, 166, 0.6);
    box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2);
    backdrop-filter: blur(24px);
    border-radius: 20px;
}

.login-btn:hover {
    cursor: pointer;
}

.btn {
    border-radius: 10px !important;
    color: white !important;
    text-transform: none !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 32.68px !important;
    width: 446px !important;
    padding: 64px 10px !important;
}

.btn-text {
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 33px;
}
</style>